import {
    useParams
} from 'react-router-dom';
import MilvusConfig from './MilvusKeys';
import RedisKeys from './RedisKys';
import WatsonApiKeys from './WatsonApiKeys';
import ElasticsearchConfig from './ElasticsearchKeys';
import ConfigMailSecretsInline from './ConfigMailSecret';
import {
    Button
} from 'shared/components/ui/button';
import {
    ArrowLeft
} from 'lucide-react';

export default function ConfigurationDetails() {
    const {
        configId
    } = useParams<{ configId: string }>();

    function getConfigComponentByConfigSlug(slug: string): any {
        switch (slug) {
            case 'milvus':
                return <MilvusConfig />;
            case 'elasticsearch':
                return <ElasticsearchConfig />;
            case 'redis':
                return <RedisKeys />;
            case 'outlook':
                return <ConfigMailSecretsInline />;
            case 'ibm-watson':
                return <WatsonApiKeys />;
            default:
                return undefined;
        }
    }

    const ConfigComponent = getConfigComponentByConfigSlug(configId!);

    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <div className="flex p-8 overflow-y-scroll w-full min-w-[700px]">
            <div className='w-full'>
                <div>
                    <Button variant="outline" className="mb-6" onClick={handleGoBack}>
                        <ArrowLeft className="mr-2 size-4" />
                        Back to Integrations
                    </Button>
                </div>
                {ConfigComponent ? ConfigComponent : (
                    <div className='flex flex-col justify-center items-center'>
                        <h2 className="text-lg font-medium text-foreground">Configuration Not Found</h2>
                        <p className="text-sm text-muted-foreground">The requested configuration does not exist.</p>
                    </div>
                )}
            </div>
        </div>
    );
}
